module.exports = __webpack_public_path__ + "c3f3463fbb7e5faeac3ef0de6aef04bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-kawauso-kakuninn-memo.png
// module id = 2070
// module chunks = 4